import type { MisconceptionDefinition } from '../types';
export const tegenwoordigeTijdMisconceptions: MisconceptionDefinition[] = [
// === Inversie jij-vorm (SWW-TT-INV-JIJ) ===
{
  id: 'sww.inversie-t-niet-weg',
  label: 'Inversie niet toegepast: -t blijft staan',
  module: 'SpellingWW',
  description: 'Bij inversie (werkwoord vóór "jij") moet de -t weg: "loop jij", niet "loopt jij". Leerling laat de -t per ongeluk staan.',
  typicalFamilies: ['SWW-TT-INV-JIJ']
}, {
  id: 'sww.inversie-t-vergeten',
  label: '-t vergeten bij gewone volgorde',
  module: 'SpellingWW',
  description: 'Leerling houdt de gewone woordvolgorde aan (jij + werkwoord) maar vergeet daarbij de -t (bv. "jij loop" i.p.v. "jij loopt").',
  typicalFamilies: ['SWW-TT-INV-JIJ']
}, {
  id: 'sww.inversie-infinitief',
  label: 'Infinitief gebruikt bij inversie i.p.v. stam',
  module: 'SpellingWW',
  description: 'Leerling gebruikt het hele werkwoord (infinitief, -en vorm) bij inversie i.p.v. de stam (bv. "lopen jij" i.p.v. "loop jij").',
  typicalFamilies: ['SWW-TT-INV-JIJ']
},
// === Zijn / hebben (SWW-TT-ZIJN-HEBBEN) ===
{
  id: 'sww.zijnhebben-correct-als-fout',
  label: 'Correcte vorm van zijn/hebben aangezien als fout',
  module: 'SpellingWW',
  description: "Leerling beoordeelt een correcte vorm van zijn of hebben (bv. 'jij hebt', 'hij is', 'wij zijn') ten onrechte als foutief in een 'welke zin bevat een fout?'-vraag.",
  typicalFamilies: ['SWW-TT-ZIJN-HEBBEN']
}, {
  id: 'sww.zijnhebben-verward-bezit',
  label: 'Zijn gebruikt bij bezit',
  module: 'SpellingWW',
  description: "Leerling kiest 'zijn' waar 'hebben' hoort omdat het om BEZIT gaat (bv. 'hij is een hond' i.p.v. 'hij heeft een hond'). Mist het onderscheid bezit → hebben.",
  typicalFamilies: ['SWW-TT-ZIJN-HEBBEN']
}, {
  id: 'sww.zijnhebben-verward-gevoel',
  label: 'Hebben gebruikt bij gevoel/eigenschap/toestand',
  module: 'SpellingWW',
  description: "Leerling kiest 'hebben' waar 'zijn' hoort omdat het om een gevoel, eigenschap of toestand gaat (bv. 'zij heeft blij' i.p.v. 'zij is blij'). Mist het onderscheid eigenschap/toestand → zijn.",
  typicalFamilies: ['SWW-TT-ZIJN-HEBBEN']
}, {
  id: 'sww.zijnhebben-persoon-verward',
  label: 'Verkeerde persoonsvorm bij het onderwerp',
  module: 'SpellingWW',
  description: "Leerling koppelt de vorm aan de verkeerde persoon, met name de ik-vorm bij een ander onderwerp (bv. 'hij heb' i.p.v. 'hij heeft', of 'jij heb' i.p.v. 'jij hebt') of de hij-vorm bij 'ik' ('ik is' i.p.v. 'ik ben').",
  typicalFamilies: ['SWW-TT-ZIJN-HEBBEN']
}, {
  id: 'sww.zijnhebben-enkelvoud-meervoud',
  label: 'Enkelvoud- en meervoudsvorm verwisseld',
  module: 'SpellingWW',
  description: "Leerling verwisselt de enkelvouds- en meervoudsvervoeging van zijn/hebben (bv. 'wij is' i.p.v. 'wij zijn', 'jullie is' i.p.v. 'jullie zijn', of 'hij hebben' i.p.v. 'hij heeft'). Past de enkelvoudsregel toe op een meervoudig onderwerp of omgekeerd.",
  typicalFamilies: ['SWW-TT-ZIJN-HEBBEN']
}, {
  id: 'sww.zijnhebben-meervoud-bij-enkelvoud',
  label: 'Meervoudsvorm gebruikt bij enkelvoud onderwerp',
  module: 'SpellingWW',
  description: "Leerling kiest de meervoudsvorm 'zijn' (of 'hebben') bij een enkelvoudig onderwerp (bv. 'hij zijn' i.p.v. 'hij is'). Herkent het enkelvoudige onderwerp niet als trigger voor de is/heeft-vorm.",
  typicalFamilies: ['SWW-TT-ZIJN-HEBBEN']
},
// === Gebiedende wijs (SWW-TT-GEBIEDENDE) ===
{
  id: 'sww.gebiedende-met-t',
  label: 'Gebiedende wijs met -t geschreven',
  module: 'SpellingWW',
  description: 'Leerling schrijft de gebiedende wijs als jij/hij-vorm met -t (bv. "Wordt!" i.p.v. "Word!"), terwijl de gebiedende wijs altijd de stam zonder -t is.',
  typicalFamilies: ['SWW-TT-GEBIEDENDE']
},
// === Generiek "welke is fout?"-vraagtype ===
{
  // GEMIGREERD (juni 2026): was 'sww.correct-form-marked-wrong' (EN-legacy).
  id: 'sww.correcte-vorm-als-fout',
  label: 'Correcte vorm aangezien als fout',
  module: 'SpellingWW',
  description: "Leerling kiest een correct geschreven vorm als 'fout' in een vraagtype dat vraagt welk antwoord verkeerd geschreven is.",
  typicalFamilies: ['SWW-TT-GEBIEDENDE', 'SWW-TT-ZIJN-HEBBEN', 'SWW-VD-HOMOFOON']
},
// === Meervoud tegenwoordige tijd (SWW-TT-MEERVOUD) ===
{
  id: 'sww.meervoud-als-enkelvoud-vervoegd',
  label: 'Meervoudig onderwerp vervoegd als enkelvoud',
  module: 'SpellingWW',
  description: "Leerling gebruikt bij een meervoudig onderwerp (wij/jullie/zij/de kinderen) de stam+t-vorm i.p.v. de infinitief (bv. 'de kinderen speelt' of 'wij fietst'). Verward de enkelvoudsregel met de meervoudsregel.",
  typicalFamilies: ['SWW-TT-MEERVOUD']
}, {
  id: 'sww.stam-alleen-bij-meervoud',
  label: 'Stam alleen gebruikt bij meervoud (ik-vorm)',
  module: 'SpellingWW',
  description: "Leerling gebruikt bij meervoud de kale stam (ik-vorm) i.p.v. de infinitief (bv. 'wij werk' of 'de vogels vlieg'). Mist het besef dat alleen 'ik' de stam zonder -t/-en gebruikt.",
  typicalFamilies: ['SWW-TT-MEERVOUD']
},
// === Gebiedende wijs herkennen (SWW-TT-GEBIEDENDE) ===
{
  id: 'sww.gebiedende-niet-herkend',
  label: 'Gebiedende wijs niet herkend als bevel',
  module: 'SpellingWW',
  description: 'Leerling herkent een bevel/opdracht-zin niet als gebiedende wijs en kiest een gewone mededeling (indicatief), voltooide tijd of meervoudsvorm als zou die ook een bevel zijn.',
  typicalFamilies: ['SWW-TT-GEBIEDENDE']
}];